import {styled} from '@linaria/react';

export const UnstyledButton = styled.button`
  appearance: none;
  font: inherit;
  color: inherit;
  padding: 0;
  border: unset;
  background: transparent;
  cursor: pointer;
`;
